import { useContext, useMemo } from 'react'
import { MetaDataContext } from '../state-management/contexts/MetaDataContext'
import { MetaDataResponse, WaterfallSections, WaterfallValues } from '../types/mutual-fund-detail.types'

export function getAlternateIsinFromWaterfall(input: {
  isin: string
  metadata: MetaDataResponse | undefined
  waterfallKey: `${WaterfallSections}`
}): { alternateISIN: string; config: `${WaterfallValues}` | undefined } {
  const { isin, metadata, waterfallKey } = input
  const config = metadata?.sectionAvailability?.[waterfallKey]
  if (config === WaterfallValues.YES) return { alternateISIN: isin, config }
  if (config === WaterfallValues.YES_DIRECT)
    return { alternateISIN: metadata?.fundFamilyDirectFundIsin ?? '', config }
  return { alternateISIN: '', config }
}

const useAlternateISIN = (waterfallKey: `${WaterfallSections}`) => {
  const metaContext = useContext(MetaDataContext)

  return useMemo(
    () =>
      getAlternateIsinFromWaterfall({
        isin: metaContext?.isin ?? '',
        metadata: metaContext?.data,
        waterfallKey
      }),
    [metaContext?.isin, metaContext?.data, waterfallKey]
  )
}

export default useAlternateISIN
